import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"enable-background":"new 0 0 16 16"},
  "xml:space": "preserve",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-2009"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M1.703 12.08h12.594a.7.7 0 0 0 .7-.702V3.543a.7.7 0 1 0-1.4 0v7.132H2.403V3.543a.704.704 0 0 0-.7-.702c-.384 0-.7.317-.7.702v7.834c0 .388.313.703.7.703z" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "M4.14 6.273h2.648L5.463 8.566a.701.701 0 0 0 1.214.699L8 6.973l1.324 2.293a.7.7 0 1 0 1.213-.699L9.213 6.273h2.648a.7.7 0 1 0 0-1.4H9.212l1.324-2.294a.7.7 0 0 0-1.212-.699L8 4.173 6.676 1.88a.7.7 0 0 0-1.213.699l1.324 2.294H4.14a.7.7 0 1 0 0 1.4zm10.3 7.015H1.56a.7.7 0 1 0 0 1.4h12.88a.7.7 0 1 0 0-1.4z" }, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }